<template>
    <section :style="style" class="muhurat-banner-section">
        <div class="container diwali-refer-container">
            <div class="muhurat-card">
                <!-- New Animated Diwali Background -->
                <div class="muhurat-card__bg" aria-hidden="true">
                    <img src="~/assets/images/home/event_banner_bg.svg" alt="Diwali Background" />
                </div>

                <!-- Content -->
                <div class="muhurat-content">
                    <h2 class="muhurat-title">
                        Happy Diwali
                    </h2>
                    <p class="muhurat-description">
                        May this festival of lights bring bright prosperity, happiness, and secure growth to your wealth. Warm wishes from Team Equirize.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useTheme } from "~/composables/useTheme";
const { colors } = useTheme();

interface Props {
    style?: any;
}

defineProps<Props>();
</script>

<style scoped>
.muhurat-banner-section {
    padding: 60px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.diwali-refer-container {
    margin: 0 auto;
    width: 80%;
}

.muhurat-card {
    background-color: #005EB6;
    border-radius: 10px !important; /* rx="10" from original SVG */
    padding: 24px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    color: var(--buttonText);
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    position: relative;
    min-height: 165px !important;
}

.muhurat-card__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
}

.muhurat-card__bg img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.muhurat-content {
    position: relative;
    z-index: 2;
    flex: 1;
    max-width: 900px;
    padding-right: 280px !important; /* Reserves right 35% for girl & gift box illustrations */
}

.muhurat-title {
    color: #FED202 !important; /* Vivid gold yellow matching fe-investor */
    font-size: 26px !important;
    font-weight: 800 !important;
    margin-bottom: 6px !important;
    line-height: 1.1;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.muhurat-description {
    color: #ffffff !important; /* Clean white matching user attachment */
    font-size: 15px !important;
    line-height: 1.4 !important;
    margin-bottom: 0 !important;
    opacity: 0.95;
}

@media (max-width: 768px) {
    .muhurat-card {
        min-height: auto !important;
        padding: 20px !important;
    }
    .muhurat-content {
        padding-right: 0 !important; /* Fold elements gracefully on mobile */
    }
    .muhurat-card__bg {
        /* Increase backdrop contrast on mobile */
    }
    .muhurat-title {
        font-size: 22px !important;
    }
    .muhurat-description {
        font-size: 13px !important;
    }
}
</style>
